import packageJson from "../package.json"

const version = packageJson.version;

export default version;